import React, { useState, useEffect } from "react";
import axios from "axios";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";


function SubscribedUser() {
  const [formData, setFormData] = useState({
    user_id: "",
    subscription_id: "",
    transaction_id: "",
    status: "",
    pay_amount: "",
    device_id: "",
  });

  const [message, setMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState("success");
  const [subscriptions, setSubscriptions] = useState([]);
  const [devices, setDevices] = useState([]);

  const [users, setUsers] = useState([]);
  //for user id
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/allusers`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(res.data.data || []);
      } catch (error) {
        console.error("Failed to fetch users", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, []);

  //for 

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/get-devices`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("Fetched devices:", res.data);
        setDevices(res.data.data || []);
      } catch (error) {
        console.error("Failed to fetch devices", error);
        setDevices([]);
      }
    };

    fetchDevices();
  }, []);


  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/getall-subscription`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSubscriptions(response.data.data || []);
      } catch (error) {
        console.error("Failed to fetch subscriptions:", error);
        setSubscriptions([]);
      }
    };

    fetchSubscriptions();
  }, []);


  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();


    if (
      !formData.user_id ||
      !formData.subscription_id ||
      !formData.transaction_id

    ) {
      setMessage(
        "Please fill in all required fields"
      );
      setSnackbarType("error");
      setSnackbarOpen(true);
      return;
    }

    try {

      const data = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        if (value !== "") {
          data.append(key, value);
        }
      });

      const token = localStorage.getItem("access_token");
      if (!token) {
        setMessage("Access token not found. Please log in again.");
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/subscribed-user`,
        data,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === false) {
        setMessage(response.data.message);
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      setMessage("Subscribed user created successfully");
      setSnackbarType("success");
      setSnackbarOpen(true);
      console.log("Subscribed user created:", response.data);

      setFormData({
        user_id: "",
        subscription_id: "",
        transaction_id: "",
        status: "",
        pay_amount: "",
        device_id: "",
      });
    } catch (error) {
      console.error("Error creating subscribed user", error);
      if (error.response?.data?.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage("Failed to create subscribed user. Please try again.");
        setSnackbarType("error");
        setSnackbarOpen(true);
      }
    }
  };
  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar absolute isMini />
      <MDBox mt={8} mb={8}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={10} lg={8}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="medium" mb={3}>
                  Create Subscribed User
                </MDTypography>

                <MDBox component="form" role="form" onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <MDTypography fontWeight="regular" display="block" style={{ fontSize: "0.75rem", marginBottom: "8px", color: "#555" }}>
                        User ID
                      </MDTypography>
                      <select
                        name="user_id"
                        value={formData.user_id}
                        onChange={handleChange}
                        style={{ width: "100%", padding: "8px 12px", fontSize: "0.9rem", borderRadius: "6px", border: "1.5px solid #ccc", backgroundColor: "#fafafa", cursor: "pointer" }}
                      >
                        <option value="" disabled>Select User ID</option>
                        {users.length > 0 ? users.map((user) => (
                          <option key={user.id} value={user.id}>{user.name}</option>
                        )) : <option disabled>No users available</option>}
                      </select>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <MDTypography fontWeight="regular" display="block" style={{ fontSize: "0.75rem", marginBottom: "8px", color: "#555" }}>
                        Subscription ID
                      </MDTypography>
                      <select
                        name="subscription_id"
                        value={formData.subscription_id}
                        onChange={handleChange}
                        style={{ width: "100%", padding: "8px 12px", fontSize: "0.9rem", borderRadius: "6px", border: "1.5px solid #ccc", backgroundColor: "#fafafa", cursor: "pointer" }}
                      >
                        <option value="" disabled>Select Subscription</option>
                        {subscriptions.length > 0 ? subscriptions.map((sub) => (
                          <option key={sub.id} value={sub.id}>
                            {sub.id} - {sub.name || sub.title || `Plan ${sub.id}`}
                          </option>
                        )) : <option disabled>No subscriptions available</option>}
                      </select>
                    </Grid>
                    <Grid item xs={12} >
                      <MDTypography fontWeight="regular" display="block" style={{ fontSize: "0.75rem", marginBottom: "8px", color: "#555" }}>
                        Device ID
                      </MDTypography>
                      <select
                        name="device_id"
                        value={formData.device_id}
                        onChange={handleChange}
                        style={{ width: "100%", padding: "8px 12px", fontSize: "0.9rem", borderRadius: "6px", border: "1.5px solid #ccc", backgroundColor: "#fafafa", cursor: "pointer" }}
                      >
                        <option value="" disabled>Select Device ID</option>
                        {devices.length > 0 ? devices.map((device) => (
                          <option key={device.device_id} value={device.device_id}>
                            {device.device_id}
                          </option>
                        )) : <option disabled>No devices available</option>}
                      </select>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <MDInput
                        label="Transaction ID"
                        name="transaction_id"
                        type="text"
                        fullWidth
                        value={formData.transaction_id}
                        onChange={handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <MDInput
                        type="text"
                        label="Status"
                        name="status"
                        fullWidth
                        value={formData.status}
                        onChange={handleChange}
                      />
                    </Grid>



                    <Grid item xs={12} >
                      <MDInput
                        type="number"
                        label="Pay Amount"
                        name="pay_amount"
                        fullWidth
                        value={formData.pay_amount}
                        onChange={handleChange}
                      />
                    </Grid>
                  </Grid>


                  <MDBox mt={4} mb={1}>
                    <MDButton variant="gradient" color="info" type="submit" fullWidth>
                      Create Subscribed User
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleSnackbarClose}
          severity={snackbarType}
          elevation={6}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </MuiAlert>
      </Snackbar>

      <Footer />
    </DashboardLayout>
  );
}

export default SubscribedUser;
